/**
 * @generated SignedSource<<bf16115125750f334cf2c960c95b9538>>
 * @relayHash fa6eabdd73ea298014e50d3dd4da7212
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d722f0a264d9c6d57bd9721e29e99f0c95bb1312bb0be0607aeb056711078292

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiIssueNotificationLogsPageQuery } from './uiIssueNotificationLogsPageQuery.graphql';

const node: PreloadableConcreteRequest<uiIssueNotificationLogsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d722f0a264d9c6d57bd9721e29e99f0c95bb1312bb0be0607aeb056711078292",
    "metadata": {},
    "name": "uiIssueNotificationLogsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
